import { Typography } from "@/components/ui/typography";
import { cn } from "@/components/ui/utils";

export function SharedReportSidebar({
  groups,
  selectedGroupId,
  onGroupChange,
}: {
  groups: Array<{ id: string; label: string }>;
  selectedGroupId: string;
  onGroupChange: (groupId: string) => void;
}) {
  return (
    <nav
      aria-label="Report sections"
      className="w-full h-full min-h-0 overflow-y-auto pt-2 pb-2 pl-2 pr-2"
    >
      {groups.map((group) => {
        const isSelected = group.id === selectedGroupId;
        return (
          <div
            key={group.id}
            role="tab"
            aria-selected={isSelected}
            data-testid={`shared-report-group-${group.id}`}
            onClick={() => onGroupChange(group.id)}
            className={cn(
              "pt-1 pb-1 pl-2 pr-2 mb-px h-7 rounded-sm cursor-pointer flex items-center",
              isSelected ? "bg-secondary" : "bg-transparent",
              "[transition:background-color_0.1s] hover:bg-secondary",
            )}
          >
            <Typography
              level="body-md"
              className={cn(
                "truncate",
                isSelected ? "text-foreground" : "text-muted-foreground",
              )}
            >
              {group.label}
            </Typography>
          </div>
        );
      })}
    </nav>
  );
}
